class PriceSwitch {
  constructor() {
    this.taxRate = 0.19; // 19% MwSt
    this.isNetPrice = this.loadNetPriceSetting(); // Lade gespeicherte Einstellung
    this.originalPrices = new Map(); // Speichert die Originalpreise
    this.styleAdded = false; // Flag für einmaliges Hinzufügen des Styles
    this.debounceTime = 250; // Erhöhte Debounce-Zeit für bessere Performance
    this.init();
  }

  // Neue Methode zum Laden der gespeicherten Einstellung
  loadNetPriceSetting() {
    const savedSetting = localStorage.getItem('priceSwitchNetPrice');
    return savedSetting === 'true';
  }

  // Neue Methode zum Speichern der Einstellung
  saveNetPriceSetting() {
    localStorage.setItem('priceSwitchNetPrice', this.isNetPrice);
  }

  init() {
    // Füge Styles nur einmal hinzu
    this.addStyles();
    // Switch Button erstellen
    this.createSwitchButton();
    // Event Listener für Preisänderungen
    this.observePriceChanges();
    // Event Listener für Variantenauswahl
    this.observeVariantChanges();
  }

  addStyles() {
    if (this.styleAdded) return;
    
    const style = document.createElement('style');
    style.textContent = `
      .price-switch-container {
        display: flex !important;
        align-items: center !important;
        margin-top: 1rem !important;
        margin-bottom: 3rem !important;
        font-size: 0.9rem !important;
        color: var(--color-foreground) !important;
        width: 100% !important;
        max-width: 100% !important;
      }
      .price-switch-container .switch {
        position: relative !important;
        display: inline-block !important;
        width: 60px !important;
        height: 34px !important;
        margin-right: 10px !important;
      }
      .price-switch-container .switch input {
        opacity: 0 !important;
        width: 0 !important;
        height: 0 !important;
      }
      .price-switch-container .slider {
        position: absolute !important;
        cursor: pointer !important;
        top: 0 !important;
        left: 0 !important;
        right: 0 !important;
        bottom: 0 !important;
        background-color: #ccc !important;
        transition: .4s !important;
        border-radius: 34px !important;
      }
      .price-switch-container .slider:before {
        position: absolute !important;
        content: "" !important;
        height: 26px !important;
        width: 26px !important;
        left: 4px !important;
        bottom: 4px !important;
        background-color: white !important;
        transition: .4s !important;
        border-radius: 50% !important;
      }
      .price-switch-container input:checked + .slider {
        background-color: #ffe34e !important;
      }
      .price-switch-container input:checked + .slider:before {
        transform: translateX(26px) !important;
      }
      .price-switch-container .switch-text {
        font-size: 1.2rem !important;
        line-height: 1.2 !important;
      }
    `;
    document.head.appendChild(style);
    this.styleAdded = true;
  }

  createSwitchButton() {
    const checkPrices = setInterval(() => {
      const isProductPage = document.querySelector('.product__info-container') !== null;
      if (!isProductPage) return;

      const priceContainer = document.querySelector('.product__info-container .price');
      if (!priceContainer) return;

      const existingSwitch = priceContainer.parentNode.querySelector('.price-switch-container');
      if (existingSwitch) {
        existingSwitch.remove();
      }

      clearInterval(checkPrices);

      const switchContainer = document.createElement('div');
      switchContainer.className = 'price-switch-container';

      const switchLabel = document.createElement('label');
      switchLabel.className = 'switch';

      const switchInput = document.createElement('input');
      switchInput.type = 'checkbox';
      switchInput.checked = this.isNetPrice;

      const switchSlider = document.createElement('span');
      switchSlider.className = 'slider';

      const switchText = document.createElement('span');
      switchText.className = 'switch-text';
      switchText.textContent = this.isNetPrice ? 'exklusive 19% Mehrwertsteuer' : 'inklusive 19% Mehrwertsteuer';

      switchLabel.appendChild(switchInput);
      switchLabel.appendChild(switchSlider);
      switchContainer.appendChild(switchLabel);
      switchContainer.appendChild(switchText);

      priceContainer.parentNode.insertBefore(switchContainer, priceContainer.nextSibling);

      // Initiale Preisaktualisierung
      this.updateAllPrices();

      let timeout;
      switchInput.addEventListener('change', (e) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          this.isNetPrice = e.target.checked;
          this.saveNetPriceSetting();
          switchText.textContent = this.isNetPrice ? 'exklusive 19% Mehrwertsteuer' : 'inklusive 19% Mehrwertsteuer';
          this.updateAllPrices();
        }, this.debounceTime);
      });
    }, 100);
  }

  observePriceChanges() {
    let timeout;
    const observer = new MutationObserver((mutations) => {
      // Prüfe, ob die Änderungen relevant sind
      const hasRelevantChanges = mutations.some(mutation => 
        mutation.target.classList && 
        (mutation.target.classList.contains('price-item--regular') || 
         mutation.target.classList.contains('price-item--sale'))
      );

      if (hasRelevantChanges && document.querySelector('.product__info-container')) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          this.updateAllPrices();
        }, this.debounceTime);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  observeVariantChanges() {
    let timeout;
    const observer = new MutationObserver((mutations) => {
      const hasVariantChanges = mutations.some(mutation => 
        mutation.target.classList && 
        mutation.target.classList.contains('product-form__input')
      );

      if (hasVariantChanges) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          this.createSwitchButton();
        }, this.debounceTime);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  updateAllPrices() {
    // Aktualisiere nur Preise auf der Produktseite
    const priceElements = document.querySelectorAll('.product__info-container .price-item--regular, .product__info-container .price-item--sale');
    priceElements.forEach(element => {
      // Extrahiere den Preis aus dem Text
      const priceText = element.textContent.trim();
      const currentPrice = this.parsePrice(priceText);
      
      if (currentPrice === null) return;

      // Speichere den Originalpreis, wenn er noch nicht gespeichert ist
      if (!this.originalPrices.has(element)) {
        // Speichere immer den Bruttopreis als Originalpreis
        this.originalPrices.set(element, currentPrice);
      }

      // Berechne den neuen Preis basierend auf dem gespeicherten Bruttopreis
      const newPrice = this.isNetPrice 
        ? this.originalPrices.get(element) / (1 + this.taxRate)
        : this.originalPrices.get(element);

      // Aktualisiere den Text
      const newPriceText = this.formatPrice(newPrice);
      element.textContent = newPriceText;
    });
  }

  parsePrice(priceText) {
    try {
      // Entferne das Währungssymbol und alle Leerzeichen
      priceText = priceText.replace(/[^\d,]/g, '');
      
      // Wenn kein Komma vorhanden ist, füge ",00" hinzu
      if (!priceText.includes(',')) {
        priceText += ',00';
      }
      
      // Ersetze das Komma durch einen Punkt für die Dezimalberechnung
      priceText = priceText.replace(',', '.');
      
      const price = parseFloat(priceText);
      
      // Überprüfe, ob der Preis gültig ist
      if (isNaN(price) || price < 0) {
        console.warn('Ungültiger Preis gefunden:', priceText);
        return null;
      }
      
      return price;
    } catch (error) {
      console.error('Fehler beim Parsen des Preises:', priceText, error);
      return null;
    }
  }

  formatPrice(price) {
    try {
      // Runde auf 2 Dezimalstellen
      price = Math.round(price * 100) / 100;
      
      return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(price);
    } catch (error) {
      console.error('Fehler beim Formatieren des Preises:', price, error);
      return '0,00 €';
    }
  }
}

// Initialisierung
document.addEventListener('DOMContentLoaded', () => {
  new PriceSwitch();
}); 